import React, { useState, useEffect } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import Swal from "sweetalert2";
import axios from "axios";

const AdminDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [userInfo, setUserInfo] = useState({
    role: "Guest",
    name: "Guest",
    full_name: "Guest",
  });
  const [tanggal, setTanggal] = useState("");
  const [userDetail, setUserDetail] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editData, setEditData] = useState({ id: "", lahans: [] });

  useEffect(() => {
    setTanggal(
      new Date().toLocaleDateString("id-ID", {
        weekday: "long",
        day: "numeric",
        month: "long",
        year: "numeric",
      })
    );

    // Ambil informasi admin yang sedang login
    axios
      .get("https://c-greenproject.org:7500/get_user_role", {
        withCredentials: true,
      })
      .then((response) => {
        const data = response.data;
        if (!data.error) {
          setUserInfo({
            role: data.role,
            name: data.name,
            full_name: data.full_name,
          });
        }
      })
      .catch((error) => console.error("Error fetching user info:", error));

    fetchUserDetail();
  }, [id]);

  const fetchUserDetail = async () => {
    try {
      const response = await axios.get(
        `https://c-greenproject.org:7500/users_detail?id=${id}`
      );
      if (response.status !== 200) {
        throw new Error("Failed to fetch user detail");
      }

      const data = response.data;
      const foundUser = data.users.find((user) => user.id === parseInt(id));

      if (!foundUser) {
        Swal.fire("Error", "Detail pengguna tidak ditemukan!", "error");
        navigate("/admins");
        return;
      }

      setUserDetail(foundUser);
      setEditData(foundUser);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching user detail:", error);
      Swal.fire("Error", "Gagal mengambil data detail pengguna!", "error");
      setLoading(false);
    }
  };

  const handleLogout = async () => {
    try {
      await axios.post(
        "https://c-greenproject.org:7500/logout",
        {},
        { withCredentials: true }
      );
      navigate("/");
    } catch (error) {
      console.error("Error during logout:", error);
      alert("Gagal logout. Silakan coba lagi.");
    }
  };

  const handleEditSubmit = async () => {
    if (!editData.id) {
      Swal.fire("Error", "User ID tidak ditemukan!", "error");
      return;
    }

    try {
      // Validasi lahan jika role-nya petani
      if (editData.role === "petani" && Array.isArray(editData.lahan)) {
        for (let lahan of editData.lahan) {
          if (
            !lahan.nama_lahan ||
            !lahan.alamat_lahan ||
            !lahan.status_sertifikasi_lahan ||
            !lahan.luas_lahan
          ) {
            Swal.fire(
              "Error",
              "Semua field lahan harus diisi dengan lengkap.",
              "error"
            );
            return;
          }
        }
      }

      const response = await axios.put("https://c-greenproject.org:7500/edit", {
        user_id: editData.id,
        nama: editData.nama,
        nomor_hp: editData.nomor_hp,
        alamat_rumah: editData.alamat_rumah,
        alamat_kebun: editData.alamat_kebun,
        alamat_pabrik: editData.alamat_pabrik,
        alamat_email: editData.alamat_email || editData.email,
        role: editData.role,
        lahans:
          editData.lahan?.map((lahan) => ({
            lahan_id: lahan.id,
            nama_lahan: lahan.nama_lahan,
            alamat_lahan: lahan.alamat_lahan,
            status_sertifikasi_lahan: lahan.status_sertifikasi_lahan,
            luas_lahan: parseFloat(lahan.luas_lahan || 0),
          })) || [],
        jenis_sawit: editData.jenis_sawit,
        jenis_pupuk: editData.jenis_pupuk,
        kapasitas_penyimpanan: editData.kapasitas_penyimpanan,
        kapasitas_produksi: editData.kapasitas_produksi,
      });

      Swal.fire(
        "Sukses",
        response.data.message || "Pengguna berhasil diperbarui!",
        "success"
      );
      setShowEditModal(false);
      fetchUserDetail();
    } catch (error) {
      console.error("Error during edit:", error);
      const backendMessage =
        error.response?.data?.error ||
        error.response?.data?.message ||
        "Terjadi kesalahan saat mengedit pengguna.";
      Swal.fire("Error", backendMessage, "error");
    }
  };

  const getRoleBadge = (role) => {
    const r = String(role || "").toLowerCase().trim();
    if (r === "petani") return <span className="badge bg-success-subtle text-success border border-success-subtle px-3 py-1 rounded-pill">Petani</span>;
    if (r === "logistik") return <span className="badge bg-primary-subtle text-primary border border-primary-subtle px-3 py-1 rounded-pill">Logistik</span>;
    if (r === "pabrik") return <span className="badge bg-info-subtle text-info-emphasis border border-info-subtle px-3 py-1 rounded-pill">Pabrik</span>;
    if (r === "kebun") return <span className="badge bg-warning-subtle text-warning-emphasis border border-warning-subtle px-3 py-1 rounded-pill">Kebun</span>;
    return <span className="badge bg-secondary-subtle text-secondary border border-secondary-subtle px-3 py-1 rounded-pill">{role || "-"}</span>;
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
        <div className="spinner-border text-success" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (!userDetail) return null;

  return (
    <div className="d-flex flex-column bg-light min-vh-100">
      {/* Header */}
      <div className="header bg-white shadow-sm border-bottom">
        <img src="/static/logo_potrait.png" alt="Logo" />
        <div className="top-right">
          <span className="fw-medium text-secondary">{userInfo.full_name} |</span>
          <button className="btn btn-outline-danger btn-sm rounded-pill px-3 ms-2" onClick={handleLogout}>
            Keluar
          </button>
        </div>
      </div>

      <div className="d-flex flex-grow-1">
        {/* Sidebar */}
        <div className="sidebar p-3 bg-white shadow-sm" id="sidebar">
          <p id="sidebar-title" className="text-muted small mb-1">Portal Sistem Traceability</p>
          <h6 id="sidebar-subtitle" className="fw-bold text-success mb-3">Telsa Super Apps</h6>
          <p id="sidebar-date" className="bg-light p-2 rounded-3 text-muted small fw-medium d-flex align-items-center gap-2">
            <img src="/static/schedule_11145854.png" alt="Date" style={{ width: "16px" }} />
            {tanggal}
          </p>
          <div className="list-group list-group-flush mt-3" id="sidebar-menu">
            <div
              onClick={() => navigate("/admin")}
              className={`list-group-item text-decoration-none border-0 rounded-3 mb-1 ${
                location.pathname === "/admin" ? "bg-success text-white" : ""
              }`}
              style={{ cursor: "pointer" }}
            >
              <img src="/static/eco-home_7633847.png" alt="Home" style={{ width:"20px", marginRight:"10px", filter: location.pathname === "/admin" ? "brightness(0) invert(1)" : "none" }} /> Beranda
            </div>
            <div
              onClick={() => navigate("/admins")}
              className={`list-group-item text-decoration-none border-0 rounded-3 mb-1 ${
                location.pathname.includes("/admins") ? "bg-success text-white" : ""
              }`}
              style={{ cursor: "pointer" }}
            >
              <img src="/static/sell_8087698.png" alt="Stakeholder" style={{ width:"20px", marginRight:"10px", filter: location.pathname.includes("/admins") ? "brightness(0) invert(1)" : "none" }} /> Stakeholder
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className="main-content flex-grow-1 p-4 w-100">
          
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div>
              <h2 className="fw-bold text-dark mb-1">Detail Pengguna</h2>
              <p className="text-muted mb-0 font-monospace">ID: #{userDetail.id}</p>
            </div>
            <div className="d-flex gap-2">
              <button className="btn btn-outline-secondary rounded-pill px-4" onClick={() => navigate("/admins")}>
                Kembali
              </button>
              <button 
                className="btn btn-success rounded-pill px-4 shadow-sm fw-medium"
                onClick={() => { setEditData(userDetail); setShowEditModal(true); }}
              >
                <i className="fa fa-edit me-2"></i>Edit Pengguna
              </button>
            </div>
          </div>

          <div className="divider mb-4"></div>

          <div className="row g-4">
            {/* Informasi Umum */}
            <div className="col-12 col-xl-6">
              <div className="content-box p-4 border-0 shadow-sm rounded-4 bg-white h-100">
                <h5 className="fw-bold text-success mb-4 pb-2 border-bottom">Informasi Dasar</h5>
                
                <div className="d-flex justify-content-between align-items-center py-2 border-bottom">
                  <span className="text-muted fw-semibold">ID Pengguna</span>
                  <span className="fw-bold font-monospace text-dark">#{userDetail.id}</span>
                </div>
                <div className="d-flex justify-content-between align-items-center py-2 border-bottom">
                  <span className="text-muted fw-semibold">Username</span>
                  <span className="fw-bold text-dark">{userDetail.username}</span>
                </div>
                <div className="d-flex justify-content-between align-items-center py-2 border-bottom">
                  <span className="text-muted fw-semibold">Role</span>
                  <span>{getRoleBadge(userDetail.role)}</span>
                </div>
              </div>
            </div>

            {/* Informasi Spesifik Berdasarkan Role */}
            <div className="col-12 col-xl-6">
              <div className="content-box p-4 border-0 shadow-sm rounded-4 bg-white h-100">
                <h5 className="fw-bold text-success mb-4 pb-2 border-bottom">Atribut & Kontak</h5>

                {userDetail.role === "petani" && (
                  <>
                    <div className="d-flex justify-content-between align-items-center py-2 border-bottom">
                      <span className="text-muted fw-semibold">Nama Lengkap</span>
                      <span className="fw-bold text-dark">{userDetail.nama || "-"}</span>
                    </div>
                    <div className="d-flex justify-content-between align-items-center py-2 border-bottom">
                      <span className="text-muted fw-semibold">Nomor HP</span>
                      <span className="fw-bold font-monospace text-dark">{userDetail.nomor_hp || "-"}</span>
                    </div>
                    <div className="d-flex justify-content-between align-items-center py-2">
                      <span className="text-muted fw-semibold">Alamat Rumah</span>
                      <span className="fw-bold text-dark text-end">{userDetail.alamat_rumah || "-"}</span>
                    </div>
                  </>
                )}

                {userDetail.role === "kebun" && (
                  <>
                    <div className="d-flex justify-content-between align-items-center py-2 border-bottom">
                      <span className="text-muted fw-semibold">Nama Kebun</span>
                      <span className="fw-bold text-dark">{userDetail.nama || "-"}</span>
                    </div>
                    <div className="d-flex justify-content-between align-items-center py-2 border-bottom">
                      <span className="text-muted fw-semibold">Nomor HP</span>
                      <span className="fw-bold font-monospace text-dark">{userDetail.nomor_hp || "-"}</span>
                    </div>
                    <div className="d-flex justify-content-between align-items-center py-2 border-bottom">
                      <span className="text-muted fw-semibold">Alamat Kebun</span>
                      <span className="fw-bold text-dark text-end">{userDetail.alamat_kebun || "-"}</span>
                    </div>
                    <div className="d-flex justify-content-between align-items-center py-2 border-bottom">
                      <span className="text-muted fw-semibold">Jenis Sawit</span>
                      <span className="fw-bold text-dark">{userDetail.jenis_sawit || "-"}</span>
                    </div>
                    <div className="d-flex justify-content-between align-items-center py-2">
                      <span className="text-muted fw-semibold">Jenis Pupuk</span>
                      <span className="fw-bold text-dark">{userDetail.jenis_pupuk || "-"}</span>
                    </div>
                  </>
                )}

                {userDetail.role === "logistik" && (
                  <>
                    <div className="d-flex justify-content-between align-items-center py-2 border-bottom">
                      <span className="text-muted fw-semibold">Nama Logistik</span>
                      <span className="fw-bold text-dark">{userDetail.nama || "-"}</span>
                    </div>
                    <div className="d-flex justify-content-between align-items-center py-2 border-bottom">
                      <span className="text-muted fw-semibold">Nomor HP</span>
                      <span className="fw-bold font-monospace text-dark">{userDetail.nomor_hp || "-"}</span>
                    </div>
                    <div className="d-flex justify-content-between align-items-center py-2">
                      <span className="text-muted fw-semibold">Alamat</span>
                      <span className="fw-bold text-dark text-end">{userDetail.alamat || "-"}</span>
                    </div>
                  </>
                )}

                {userDetail.role === "pabrik" && (
                  <>
                    <div className="d-flex justify-content-between align-items-center py-2 border-bottom">
                      <span className="text-muted fw-semibold">Nama Pabrik</span>
                      <span className="fw-bold text-dark">{userDetail.nama || "-"}</span>
                    </div>
                    <div className="d-flex justify-content-between align-items-center py-2 border-bottom">
                      <span className="text-muted fw-semibold">Nomor HP</span>
                      <span className="fw-bold font-monospace text-dark">{userDetail.nomor_hp || "-"}</span>
                    </div>
                    <div className="d-flex justify-content-between align-items-center py-2 border-bottom">
                      <span className="text-muted fw-semibold">Alamat Pabrik</span>
                      <span className="fw-bold text-dark text-end">{userDetail.alamat_pabrik || "-"}</span>
                    </div>
                    <div className="d-flex justify-content-between align-items-center py-2 border-bottom">
                      <span className="text-muted fw-semibold">Kapasitas Penyimpanan</span>
                      <span className="fw-bold text-dark">{userDetail.kapasitas_penyimpanan || "-"}</span>
                    </div>
                    <div className="d-flex justify-content-between align-items-center py-2">
                      <span className="text-muted fw-semibold">Kapasitas Produksi</span>
                      <span className="fw-bold text-dark">{userDetail.kapasitas_produksi || "-"}</span>
                    </div>
                  </>
                )}
              </div>
            </div>

            {/* Tabel Lahan Jika Petani */}
            {userDetail.role === "petani" && userDetail.lahan && userDetail.lahan.length > 0 && (
              <div className="col-12">
                <div className="content-box p-4 border-0 shadow-sm rounded-4 bg-white">
                  <h5 className="fw-bold text-success mb-3">Daftar Lahan Petani</h5>
                  <div className="table-responsive">
                    <table className="table table-bordered align-middle mb-0">
                      <thead className="table-light text-nowrap">
                        <tr>
                          <th className="text-center" style={{ width: "60px" }}>No</th>
                          <th>Nama Lahan</th>
                          <th>Alamat Lahan</th>
                          <th>Status Sertifikasi</th>
                          <th className="text-center">Luas (Ha)</th>
                        </tr>
                      </thead>
                      <tbody>
                        {userDetail.lahan.map((lahan, idx) => (
                          <tr key={lahan.id || idx}>
                            <td className="text-center fw-bold text-muted">{idx + 1}</td>
                            <td className="fw-semibold text-dark">{lahan.nama_lahan}</td>
                            <td className="text-muted">{lahan.alamat_lahan}</td>
                            <td>{lahan.status_sertifikasi_lahan}</td>
                            <td className="text-center fw-bold font-monospace">{lahan.luas_lahan} Ha</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Modal Edit Pengguna */}
      {showEditModal && editData && (
        <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: "rgba(0,0,0,0.6)" }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content border-0 shadow-lg rounded-4">
              <div className="modal-header border-bottom-0 pb-0 pt-4 px-4">
                <h5 className="modal-title fw-bold text-dark">Edit Pengguna</h5>
                <button type="button" className="btn-close shadow-none" onClick={() => setShowEditModal(false)}></button>
              </div>
              <div className="modal-body px-4 py-3" style={{ maxHeight: "70vh", overflowY: "auto" }}>
                
                <div className="form-group mb-3">
                  <label className="fw-semibold text-muted small mb-1">Username (Read-only)</label>
                  <input
                    type="text"
                    className="form-control rounded-3 bg-light"
                    value={editData.username || ""}
                    readOnly
                  />
                </div>

                <div className="form-group mb-3">
                  <label className="fw-semibold text-muted small mb-1">Nama</label>
                  <input
                    type="text"
                    className="form-control rounded-3"
                    value={editData.nama || ""}
                    onChange={(e) => setEditData({ ...editData, nama: e.target.value })}
                  />
                </div>

                <div className="form-group mb-3">
                  <label className="fw-semibold text-muted small mb-1">Nomor HP</label>
                  <input
                    type="text"
                    className="form-control rounded-3"
                    value={editData.nomor_hp || ""}
                    onChange={(e) => setEditData({ ...editData, nomor_hp: e.target.value })}
                  />
                </div>

                {editData.role === "petani" && (
                  <>
                    <div className="form-group mb-3">
                      <label className="fw-semibold text-muted small mb-1">Alamat Rumah</label>
                      <input
                        type="text"
                        className="form-control rounded-3"
                        value={editData.alamat_rumah || ""}
                        onChange={(e) => setEditData({ ...editData, alamat_rumah: e.target.value })}
                      />
                    </div>
                    {editData.lahan && editData.lahan.map((lahan, idx) => (
                      <div key={lahan.id || idx} className="p-3 bg-light rounded-3 mb-3 border">
                        <p className="fw-bold small text-success mb-2">Lahan #{idx + 1}</p>
                        <div className="mb-2">
                          <label className="small text-muted">Nama Lahan</label>
                          <input
                            type="text"
                            className="form-control form-control-sm rounded-2"
                            value={lahan.nama_lahan || ""}
                            onChange={(e) => {
                              const updatedLahan = [...editData.lahan];
                              updatedLahan[idx].nama_lahan = e.target.value;
                              setEditData({ ...editData, lahan: updatedLahan });
                            }}
                          />
                        </div>
                        <div className="mb-2">
                          <label className="small text-muted">Alamat Lahan</label>
                          <input
                            type="text"
                            className="form-control form-control-sm rounded-2"
                            value={lahan.alamat_lahan || ""}
                            onChange={(e) => {
                              const updatedLahan = [...editData.lahan];
                              updatedLahan[idx].alamat_lahan = e.target.value;
                              setEditData({ ...editData, lahan: updatedLahan });
                            }}
                          />
                        </div>
                        <div className="mb-2">
                          <label className="small text-muted">Status Sertifikasi</label>
                          <input
                            type="text"
                            className="form-control form-control-sm rounded-2"
                            value={lahan.status_sertifikasi_lahan || ""}
                            onChange={(e) => {
                              const updatedLahan = [...editData.lahan];
                              updatedLahan[idx].status_sertifikasi_lahan = e.target.value;
                              setEditData({ ...editData, lahan: updatedLahan });
                            }}
                          />
                        </div>
                        <div>
                          <label className="small text-muted">Luas Lahan (Ha)</label>
                          <input
                            type="number"
                            className="form-control form-control-sm rounded-2"
                            value={lahan.luas_lahan || ""}
                            onChange={(e) => {
                              const updatedLahan = [...editData.lahan];
                              updatedLahan[idx].luas_lahan = e.target.value;
                              setEditData({ ...editData, lahan: updatedLahan });
                            }}
                          />
                        </div>
                      </div>
                    ))}
                  </>
                )}

                {editData.role === "kebun" && (
                  <>
                    <div className="form-group mb-3">
                      <label className="fw-semibold text-muted small mb-1">Alamat Kebun</label>
                      <input
                        type="text"
                        className="form-control rounded-3"
                        value={editData.alamat_kebun || ""}
                        onChange={(e) => setEditData({ ...editData, alamat_kebun: e.target.value })}
                      />
                    </div>
                    <div className="form-group mb-3">
                      <label className="fw-semibold text-muted small mb-1">Jenis Sawit</label>
                      <input
                        type="text"
                        className="form-control rounded-3"
                        value={editData.jenis_sawit || ""}
                        onChange={(e) => setEditData({ ...editData, jenis_sawit: e.target.value })}
                      />
                    </div>
                    <div className="form-group mb-3">
                      <label className="fw-semibold text-muted small mb-1">Jenis Pupuk</label>
                      <input
                        type="text"
                        className="form-control rounded-3"
                        value={editData.jenis_pupuk || ""}
                        onChange={(e) => setEditData({ ...editData, jenis_pupuk: e.target.value })}
                      />
                    </div>
                  </>
                )}

                {editData.role === "logistik" && (
                  <div className="form-group mb-3">
                    <label className="fw-semibold text-muted small mb-1">Alamat Logistik</label>
                    <input
                      type="text"
                      className="form-control rounded-3"
                      value={editData.alamat || ""}
                      onChange={(e) => setEditData({ ...editData, alamat: e.target.value })}
                    />
                  </div>
                )}

                {editData.role === "pabrik" && (
                  <>
                    <div className="form-group mb-3">
                      <label className="fw-semibold text-muted small mb-1">Alamat Pabrik</label>
                      <input
                        type="text"
                        className="form-control rounded-3"
                        value={editData.alamat_pabrik || ""}
                        onChange={(e) => setEditData({ ...editData, alamat_pabrik: e.target.value })}
                      />
                    </div>
                    <div className="form-group mb-3">
                      <label className="fw-semibold text-muted small mb-1">Kapasitas Penyimpanan</label>
                      <input
                        type="text"
                        className="form-control rounded-3"
                        value={editData.kapasitas_penyimpanan || ""}
                        onChange={(e) => setEditData({ ...editData, kapasitas_penyimpanan: e.target.value })}
                      />
                    </div>
                    <div className="form-group mb-3">
                      <label className="fw-semibold text-muted small mb-1">Kapasitas Produksi</label>
                      <input
                        type="text"
                        className="form-control rounded-3"
                        value={editData.kapasitas_produksi || ""}
                        onChange={(e) => setEditData({ ...editData, kapasitas_produksi: e.target.value })}
                      />
                    </div>
                  </>
                )}

              </div>
              <div className="modal-footer border-top-0 pt-0 px-4 pb-4">
                <button type="button" className="btn btn-light rounded-pill px-4 fw-medium" onClick={() => setShowEditModal(false)}>
                  Batal
                </button>
                <button type="button" className="btn btn-success rounded-pill px-4 fw-bold shadow-sm" onClick={handleEditSubmit}>
                  Simpan Perubahan
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminDetail;